import React from 'react';
import { Link } from 'react-router-dom';
import Footer from './components/landing/Footer';

const LegalSearchBeta = () => {
  const stats = [
    { number: "40+", label: "Active Users" },
    { number: "30+", label: "Law Firms" },
    { number: "95%", label: "Success Rate" }
  ];

  const values = [
    {
      title: "Innovation",
      description: "We're constantly pushing boundaries to create better solutions for legal professionals.",
      icon: "🚀"
    },
    {
      title: "Trust",
      description: "Building lasting relationships through transparency and reliability.",
      icon: "🤝"
    },
    {
      title: "Excellence",
      description: "Committed to delivering the highest quality service to our clients.",
      icon: "⭐"
    }
  ];

  const team = [
    {
      name: "Sanay Shajith",
      role: "CEO",
      image: "/user_input_photo.png",
      linkedin: "https://www.linkedin.com/in/sanayshajith/"
    },
    {
      name: "Meeth Naik",
      role: "CTO",
      image: "/user_input_photo.png",
      linkedin: "https://www.linkedin.com/in/meeth-naik/"
    }
  ];

  return (
    <div className="company-page">
      <div className="company-section">
        {/* Hero Section */}
        <section className="hero-section">
          <div className="container">
            <div className="hero-content">
              <h1 className="hero-title">
                <span className="glitch-container">
                  <span className="glitch-layer glitch2">Revolutionizing</span>
                  <span className="glitch-layer glitch3">Revolutionizing</span>
                  <span className="glitch-main">Revolutionizing</span>
                </span>
                <span className="gradient-text"> Legal Tech</span>
              </h1>
              <p className="hero-subtitle">
                Building the future of legal services through innovation, trust, and excellence.
              </p>
              <div className="hero-buttons">
                <Link to="/signup" className="btn btn-primary">
                  Get Started
                </Link>
                <a 
                  href="https://calendly.com/sanayshajith/lawdie-intro-call" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="btn btn-secondary"
                >
                  Contact Us
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* About Section */}
        <section className="about-section">
          <div className="container">
            <div className="about-grid">
              <div className="about-content">
                <h2 className="section-title">About Lawdie</h2>
                <p className="about-text">
                  At Lawdie, we're building the future of legal practice for attorneys who refuse to be held back by outdated technology.
                </p>
                <p className="about-text">
                  We believe that every attorney—whether running a solo practice or managing a boutique firm—deserves access to the same cutting-edge tools that power the biggest law firms. That's why we've created the first comprehensive AI legal platform that consolidates research, document drafting, and client management into one intelligent system.
                </p>
                <h3 className="section-title" style={{fontSize: '2rem', marginTop: '2rem'}}>Our Mission</h3>
                <p className="about-text">
                  We're democratizing legal technology to level the playing field between big law and independent practitioners. By automating time-consuming tasks and streamlining workflows, we're helping attorneys reclaim their time, reduce overhead costs, and focus on what matters most: serving their clients.
                </p>
              </div>
              <div className="about-image">
                <div className="image-container">
                  <img 
                    src="/professional_convo.jpg" 
                    alt="About Lawdie" 
                    className="about-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Team Section */}
        <section className="team-section">
          <div className="container">
            <h2 className="section-title">Meet Our Team</h2>
            <div className="team-grid">
              {team.map((member, index) => (
                <a
                  key={index}
                  className="team-card minimal-team-card"
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: 'none', cursor: 'pointer' }}
                >
                  <div className="team-member-image">
                    <img 
                      src={member.image} 
                      alt={member.name} 
                      className="member-img"
                    />
                  </div>
                  <div className="team-member-info">
                    <h3 className="member-name">{member.name}</h3>
                    <p className="member-role">{member.role}</p>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default LegalSearchBeta; 